var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('event-registry-events-from-integration-widget',{attrs:{"contractId":_vm.contractId},on:{"updateAssetComponents":_vm.updateAssetComponents}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }